import { CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';


@Component({
  selector: 'app-nogame',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nogame.component.html',
  styleUrl: './nogame.component.scss'
})
export class NogameComponent {
  date = this.datePipe.transform(
    new Date().setDate(new Date().getDate() - 1),
    "yyyy/MM/dd"
  );


  constructor(
    private datePipe: DatePipe
  ) {}
}
